import {
  CustomDialog,
  CustomDialogContent,
  CustomDialogTrigger,
} from '@eliadmin/core/src/components/ui/custom-dialog';
import { type FieldDataItem } from '@eliadmin/core/src/stores/configurator-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { RiSearch2Line } from 'react-icons/ri';

type ConfiguratorImagePreviewProps = {
  item: FieldDataItem;
  className?: {
    preview?: string;
    trigger?: string;
  };
};

export function ConfiguratorImagePreview({ className, item }: ConfiguratorImagePreviewProps) {
  if (!item.html && !item.pic) return null;

  return (
    <>
      <CustomDialog>
        <CustomDialogTrigger asChild>
          <div className="group relative">
            <div className="absolute z-10 flex h-full w-full items-center justify-center rounded-xl bg-black/50 opacity-0 transition group-hover:opacity-100">
              <RiSearch2Line size={24} className="text-background" />
            </div>
            <div
              className={cn('h-[60px] w-[60px] md:h-[100px] md:w-[100px]', className?.trigger)}
              {...(item.html ? { style: { background: item.html } } : {})}
            >
              {item.pic && (
                <Image
                  src={`https://apieshop.smako.cz/files/data/${item.pic}`}
                  alt={item.popis}
                  fill
                  className="rounded-xl object-contain"
                />
              )}
            </div>
          </div>
        </CustomDialogTrigger>
        <CustomDialogContent
          showImageClose
          className="flex h-screen w-screen items-center justify-center border-none bg-black/50 px-6"
        >
          <div
            className={cn('relative aspect-square w-full max-w-[500px]', className?.preview)}
            {...(item.html ? { style: { background: item.html } } : {})}
          >
            {item.pic && (
              <Image
                src={`https://apieshop.smako.cz/files/data/${item.pic}`}
                alt={item.popis}
                fill
                className="max-h-[500px] max-w-[500px] rounded-xl object-contain"
              />
            )}
          </div>
        </CustomDialogContent>
      </CustomDialog>
    </>
  );
}
